import { CurrencyLogo } from 'app/components/CurrencyLogo'
import { useCurrency } from 'app/hooks/Tokens'
import React, { FC, ReactNode } from 'react'
import { Box, Tr, Td, Button } from '@chakra-ui/react'

interface TokenItemItem {
  index: any
  token: any
  apr: any
  onClickDetail(): void
  onClickStake(): void
}

// @ts-ignore TYPE NEEDS FIXING
const TokenItem: FC<TokenItemItem> = ({ index, token, apr, onClickDetail, onClickStake }) => {
  const currency = useCurrency(token.token.id)
  return (
    <>
      <Tr className="mix_tr_nl click_btn_as" onClick={onClickDetail} key={`StakeDetail-${index}`}>
        {/* <Td>{(index + 1)}</Td> */}
        <Td>1</Td>
        <Td>
          <Box className="for_line_tble for_c_logo" style={{marginRight:8}}>
            <Button className="click_btn_as box_shadov_none_btn">
              <CurrencyLogo className="hdr_btn_had hdr_btn_hadv2" currency={currency} size={35} />
            </Button>
          </Box>
          <Button className="click_btn_as box_shadov_none_btn">
            {token.token.symbol}
          </Button>
        </Td>
        <Td className="seven_32">
          {apr}
          {/* {token.strategy} */}{/* <ChevronUpIcon/> */}
        </Td>
        <Td>0.1 {token.token.symbol}</Td>
        <Td>
          <Button className="stke_tbl_btn click_btn_as" onClick={e => {e.stopPropagation(); onClickStake();}} key={`Stake-${index}`}>
            Stake
          </Button>
        </Td>
      </Tr>
    </>
  )
}

export default TokenItem
